export default "__VITE_ASSET__CMsIKV3E__"